<template>
    <app-dialog width="700px" :value="value" :title="$t('acceptPending.title')" v-bind="$attrs" @input="onCloseDialog">
        <template v-slot:content>
            <span>{{ message }}</span>
        </template>

        <template v-slot:buttons="{}">
            <v-btn text outlined class="myprovet-btn-cancel" @click="onCloseDialog"> {{ $t('common.cancel') }} </v-btn>

            <v-btn text class="myprovet-btn-ok" @click="sendEmail"> {{ $t('addressEdit.sendRequest') }} </v-btn>
        </template>
    </app-dialog>
</template>

<script>
import { mapStores } from 'pinia';
import { useBranchStore } from '@/Stores/branch';
import { axios } from '@/Services/Backend';

export default {
    props: {
        value: { default: false },
        acceptsPendingProducts: Boolean,
    },

    computed: {
        ...mapStores(useBranchStore),

        message() {
            return this.acceptsPendingProducts ? this.$t('acceptPending.stopQuestion') : this.$t('acceptPending.startQuestion');
        },
    },

    methods: {
        sendEmail() {
            axios
                .patch('/api/branches/accepts-pending-products-request', {
                    branch_id: this.branchStore.branch?.id,
                    accepts: !this.acceptsPendingProducts,
                })
                .then(() => {
                    this.showSuccess(this.$t('orders.changeRequest.sent'));
                    this.onCloseDialog();
                })
                .catch(() => {
                    this.showError(this.$t('orders.changeRequest.error'));
                    this.loading = false;
                });
        },

        onCloseDialog() {
            this.$emit('on-cancel', false);
        },
    },
};
</script>
